import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.addClasses(); // handle existing content
    // this.observeMutations(); // handle new content
  }

  addClasses() {
    const cssQuery = this.data.get("query");
    const classNames = this.data.get("classes");

    if (cssQuery && classNames) {
      const elements = this.element.querySelectorAll(cssQuery);

      elements.forEach(element => {
        element.classList.add(...classNames.split(" "));
      });
    }
  }

  // observeMutations() {
  //   const observer = new MutationObserver(() => {
  //     this.addClasses();
  //   });

  //   observer.observe(this.element, { childList: true, subtree: true });
  // }
}